import axios from 'index/axios'

// 波次列表
export function getWaveList(projectId) {
    return axios.post('/WaveManager/wave/list', { ProjectId: parseInt(projectId), Page: 1, PageSize: 100 })
}

// 波次详情
export function getWaveDetail(id) {
    return axios.get('/WaveManager/wave/detail', { id })
}

// 创建波次
export function createWave(data) {
    return axios.post('/WaveManager/wave/create', data)
}

// 更新波次
export function updateWave(data) {
    return axios.post('/WaveManager/wave/update', data)
}

// 删除波次
export function deleteWave(id) {
    return axios.post('/WaveManager/wave/delete', { Id: parseInt(id) })
}

// 获取波次经销商列表
export function getWaveDealers(waveId, params = {}) {
    return axios.post('/WaveManager/wave/dealer/list', { WaveId: parseInt(waveId), Page: 1, PageSize: 100, ...params })
}

// 批量添加经销商
export function batchAddDealers(waveId, dealers) {
    return axios.post('/WaveManager/wave/dealer/batch-add', { waveId, dealers })
}

// 生成一店一码
export function generateDealerCodes(waveId) {
    const baseUrl = window.location.protocol + '//' + window.location.host
    return axios.post('/WaveManager/wave/dealer/generate-codes', { WaveId: parseInt(waveId), BaseUrl: baseUrl })
}

// 删除经销商
export function deleteDealer(id) {
    return axios.post('/WaveManager/wave/dealer/delete', { id })
}

// 上传经销商名单（Excel）
export function uploadDealerList(formData) {
    return axios.post('/WaveManager/wave/dealer/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 导出经销商二维码
export function exportDealerQRCodes(waveId) {
    // 项目 axios 封装: get(url, params, options)
    // params 作为查询参数，options 包含 responseType
    return axios.get('/WaveManager/wave/dealer/export-qrcode', { waveId }, { responseType: 'blob' })
}
